import catQuestionnaire from "./cat";

const caatQuestionnaire = catQuestionnaire.map((question) => ({
  ...question,
  group: "caat",
}));

caatQuestionnaire.metadata = {
  titleKey: "title",
  title: "CAAT",
  introKey: "intro",
  intro:
    "This questionnaire will help you and your healthcare professional measure the impact your Lung Disease is having on your wellbeing and daily life.\nFor each item below, select the box that best describes you currently. Be sure to only select one response for each question.",
};

export default caatQuestionnaire;
